import { useAtom } from "@dbeining/react-atom";
import { Navigate, useLocation } from "react-router-dom";
import { userAtom } from "../../atoms";
import { IRole } from "../../customTypings/user/Role";
import { resolveFallbackRoute, resolveResourceLabel } from "@/utils/access/routeAccessLabels";

const PrivateRoute = ({
    children,
    roles,
}: {
    children: JSX.Element;
    roles?: Array<string>;
}) => {
    const location = useLocation();
    const currentUser = useAtom(userAtom);

    if (!currentUser) {
        return <Navigate to="/signin" state={{ from: location }} />;
    }

    if (currentUser.advisories && currentUser.advisories.twoFaSetupRequired) {
        return <Navigate to="/twofactorSetup" state={{ from: location }} />;
    }

    if (roles && !currentUser.identity.roles.some((role: IRole) => roles.indexOf(role.name) >= 0)) {
        const pathname = location.pathname + location.search;
        return (
            <Navigate
                to="/accessdenied"
                replace
                state={{
                    accessDenied: {
                        source: "route" as const,
                        attemptedPath: pathname,
                        requiredRoles: roles,
                        userRoles: currentUser.identity.roles.map((r) => r.name),
                        resourceLabel: resolveResourceLabel(location.pathname),
                        fallbackRoute: resolveFallbackRoute(location.pathname),
                        callerHint: "routeGuard" as const,
                    },
                }}
            />
        );
    }

    return children;
};

export default PrivateRoute;
